<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div>
        <strong>3D Auto Centering Gostivar</strong>
        <span>{{ $t('socialMedia') }}</span>
      </div>

      <div class="footer-actions">
        <a href="tel:+38975371855" aria-label="Call 3D Auto Centering">
          <v-icon>mdi-phone</v-icon>
        </a>
        <a href="https://www.instagram.com/3dcenteringgostivar/" target="_blank" rel="noopener" aria-label="Instagram">
          <v-icon>mdi-instagram</v-icon>
        </a>
        <a href="https://share.google/8tM8ABqWHxVpgoIeL" target="_blank" rel="noopener" :aria-label="$t('labels.leaveGoogleReview')">
          <v-icon class="review-icon">mdi-star</v-icon>
        </a>
        <a href="https://www.tiktok.com/@3dcenteringgostivar" target="_blank" rel="noopener" aria-label="TikTok">
          <img :src="tiktok" alt="TikTok">
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import Tiktok from '/public/Images/tiktok.svg';

export default {
  data: () => ({
    tiktok: Tiktok,
  }),
};
</script>

<style scoped>
.site-footer {
  background: #080a0c;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

.footer-inner {
  display: flex;
  width: min(1180px, calc(100% - 32px));
  min-height: 86px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 0 auto;
}

.footer-inner strong,
.footer-inner span {
  display: block;
}

.footer-inner strong {
  font-size: 0.98rem;
  font-weight: 950;
  text-transform: uppercase;
}

.footer-inner span {
  margin-top: 4px;
  color: #aeb6c2;
  font-size: 0.9rem;
}

.footer-actions {
  display: flex;
  gap: 10px;
}

.footer-actions a {
  display: inline-grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: white;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease;
}

.footer-actions a:hover {
  background: var(--site-orange);
  transform: translateY(-2px);
}

.footer-actions .review-icon {
  color: #fbbc04;
}

.footer-actions a:hover .review-icon {
  color: white;
}

.footer-actions img {
  width: 21px;
  height: 21px;
  filter: brightness(0) invert(1);
}

@media (max-width: 620px) {
  .footer-inner {
    min-height: 126px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
</style>
